import { VatDeclarationsPeriod } from '@features/vatDeclarations/types/vatDeclarationsPeriod'

import { AuditTrailAccountTable } from '../../../../elements/AuditTrail/types/AuditTrail'
import { VatDeclarationExportPdf } from '../VatDeclarationExportPdf'

interface BuildPdfDocumentProps {
  auditTrailData: AuditTrailAccountTable[]
  countryId?: string
  currency?: string
  data?: VatDeclarationsPeriod
  locale?: string
  organizationName?: string
  withAuditTrail?: boolean
}

export const buildPdfDocument = ({
  auditTrailData,
  data,
  organizationName,
  countryId,
  locale,
  currency,
  withAuditTrail,
}: BuildPdfDocumentProps) => {
  if (!data) {
    return undefined
  }

  return (
    <VatDeclarationExportPdf
      auditTrailData={auditTrailData}
      withAuditTrail={withAuditTrail}
      data={data}
      organizationName={organizationName}
      countryId={countryId}
      locale={locale}
      currency={currency}
    />
  )
}
